import React from 'react';

interface IProps {
  icon: string;
  isActive: boolean;
  name: string;
  handleClick: (name: string) => void;
  testId?: string;
}

export const TabButton = ({
  icon,
  isActive,
  name,
  handleClick,
  testId,
}: IProps) => {
  return (
    <button
      className={`tab-button ${isActive ? '-active' : ''}`}
      onClick={() => handleClick(name)}
      data-testid={testId}
    >
      <img src={icon} alt="" className="icon" />
      <span>{name}</span>
    </button>
  );
};
